import { createServerFn } from "@tanstack/react-start";

// The Meta Pixel ID is public (every site that runs a pixel ships it to the
// browser). It is served at runtime so the same image works on any host, and
// leaving it unset (local dev, previews) disables both the pixel and the
// cookie banner.
export const getMetaPixelId = createServerFn({ method: "GET" }).handler(async () => ({
  pixelId: process.env.META_PIXEL_ID || null,
}));
